import AWS from "aws-sdk";

const getBucketName = () => {
  const env = process.env.REACT_APP_NODE_ENV;
  if (env === "production") {
    return "lucas-production";
  }
  if (env === "staging") {
    return "lucas-staging";
  }
  return "lucas-develop";
};

const bucketRegion = "ap-northeast-1";

/** 設定 AWS S3 連線的 region 與存取金鑰，上傳前需先呼叫 */
export const setupAWS = () => {
  AWS.config.update({
    region: bucketRegion,
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  });
};

export interface UploadParam {
  file: string | Buffer | Uint8Array | Blob;
  name: string;
  pathname: string;
}

/** 將檔案上傳到 S3 指定路徑並設為公開讀取，回傳上傳結果；可傳入進度回呼 */
export const uploadPhotoToS3 = async (
  param: Partial<UploadParam>,
  progressCallback?: (progress: AWS.S3.ManagedUpload.Progress) => void,
): Promise<AWS.S3.ManagedUpload.SendData> => {
  const { file, name, pathname } = param;

  const upload = new AWS.S3.ManagedUpload({
    params: {
      Bucket: getBucketName(),
      Key: `${pathname}/${name}`,
      Body: file,
      ACL: "public-read",
    },
  });

  if (progressCallback) upload.on("httpUploadProgress", progressCallback);
  return upload.promise();
};

/** 將 VIP 圖片以 PNG 格式上傳到 S3 的 media/vip 路徑，回傳上傳結果；可傳入進度回呼 */
export const uploadVIPPhotoToS3 = async (
  param: Partial<UploadParam>,
  progressCallback?: (progress: AWS.S3.ManagedUpload.Progress) => void,
): Promise<AWS.S3.ManagedUpload.SendData> => {
  const { file, name } = param;

  const upload = new AWS.S3.ManagedUpload({
    params: {
      Bucket: getBucketName(),
      Key: `media/vip/${name}`,
      Body: file,
      ContentType: "image/png",
      ACL: "public-read",
    },
  });

  if (progressCallback) upload.on("httpUploadProgress", progressCallback);
  return upload.promise();
};
